import paper from '@/views/publicComponent/paper.vue'
import articleList from '@/views/publicComponent/articleList.vue'
export default {
    install(app) {
        app.component("paper", paper);
        app.component("articleList", articleList);
    }
}